module.exports = __webpack_public_path__ + "static/img/banner5.daa165b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner5.jpg
// module id = grkM
// module chunks = 1